import { useRef } from "react";
import successIcon from "../assets/success-icon.svg";
import EmailSentIcon from "../assets/email-sent-icon.svg";
import failureIcon from "../assets/failure-icon.svg";
import warningIcon from "../assets/warning-icon.svg";
import useCloseOnEsc from "../../shared/hooks/useCloseOnEsc";
import useOverlayClickClose from "../../shared/hooks/useOverlayClickClose";
import useInitialFocus from "../../shared/hooks/useInitialFocus";
import useFocusTrap from "../../shared/hooks/useFocusTrap";
import useReturnFocus from "../../shared/hooks/useReturnFocus";
import useLockBodyScroll from "../../shared/hooks/useLockBodyScroll";

function Modal({ isOpen, status, type, message, onClose }) {
  const modalRef = useRef(null);

  useReturnFocus(isOpen);
  useInitialFocus(isOpen, modalRef);
  useFocusTrap(isOpen, modalRef);
  useCloseOnEsc(isOpen, onClose);
  useLockBodyScroll(isOpen);

  const handleOverlayClickClose = useOverlayClickClose(isOpen, onClose);

  if (!isOpen) return null;

  const isError = status === "error";
  const isWarning = status === "warning";
  const announcementTitle = isError
    ? "Error message"
    : isWarning
      ? "Warning message"
      : "Status message";
  const announcementRole = isError ? "alert" : "status";

  const icons = {
    success: {
      default: successIcon,
      email: EmailSentIcon,
    },
    error: {
      default: failureIcon,
    },
    warning: {
      default: warningIcon,
    },
  };

  const icon = status && icons[status]?.[type || "default"];

  return (
    <div
      className="popup popup_is-opened"
      data-testid="modal-overlay"
      onMouseDown={handleOverlayClickClose}
    >
      <div
        ref={modalRef}
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        tabIndex={-1}
      >
        <h2 id="modal-title" className="visually-hidden">
          {announcementTitle}
        </h2>

        {status && icon && (
          <img
            className="modal__icon"
            src={icon}
            alt={`${message || "Status"} icon`}
          />
        )}

        <p className="modal__message" role={announcementRole}>
          {message}
        </p>

        <button
          className="close-btn popup__close-btn"
          onClick={onClose}
          aria-label="Close dialog"
        />
      </div>
    </div>
  );
}
export default Modal;
